import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Materiais from "./Materiais";
import Musicas from "./Musicas";
import Leitor from "./Leitor";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/materiais`} />
        <Route path={`${match.url}/materiais`} component={Materiais} />
        <Route path={`${match.url}/musicas`} component={Musicas} />
        <Route
          exact
          path={`${match.url}/view/:materialId`}
          component={Leitor}
        />
      </Switch>
    </div>
  );
}
